import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TeamsPlanningDetailsModal from './TeamsPlanningDetailsModal';
import './teamsPlanning.css';

export default function TeamsPlanningSeeDetailsButton({
  members = [],
  centre = 'All',
  team = 'All',
  initialMemberId = 'All',
}) {
  const { t } = useTranslation('planning');
  const [detailsOpen, setDetailsOpen] = useState(false);

  return (
    <div className="teams-planning-page">
      <button
        type="button"
        className="fu-export-btn fu-see-details-btn"
        title={t('seePlanningDetails')}
        onClick={() => setDetailsOpen(true)}
      >
        <span className="material-symbols-outlined text-[18px]">calendar_month</span>
        <span className="hidden sm:inline">{t('seeDetails')}</span>
      </button>
      <TeamsPlanningDetailsModal
        isOpen={detailsOpen}
        onClose={() => setDetailsOpen(false)}
        members={members}
        centre={centre}
        team={team}
        initialMemberId={initialMemberId}
      />
    </div>
  );
}
